import React from "react"

const GithubIcon = props => (
  <svg
    enableBackground="new 0 0 24 24"
    height={props.height}
    viewBox="0 0 24 24"
    width={props.width}
  >
    <path
      d="m12 .5c-6.63 0-12 5.28-12 11.792 0 5.211 3.438 9.63 8.205 11.188.6.111.82-.254.82-.567 0-.28-.01-1.022-.015-2.005-3.338.711-4.042-1.582-4.042-1.582-.546-1.361-1.335-1.725-1.335-1.725-1.087-.731.084-.716.084-.716 1.205.082 1.838 1.215 1.838 1.215 1.07 1.803 2.809 1.282 3.495.981.108-.763.417-1.282.76-1.577-2.665-.295-5.466-1.309-5.466-5.827 0-1.287.465-2.339 1.235-3.164-.135-.298-.54-1.497.105-3.121 0 0 1.005-.316 3.3 1.209.96-.262 1.98-.392 3-.398 1.02.006 2.04.136 3 .398 2.28-1.525 3.285-1.209 3.285-1.209.645 1.624.24 2.823.12 3.121.765.825 1.23 1.877 1.23 3.164 0 4.53-2.805 5.527-5.475 5.817.42.354.81 1.077.81 2.182 0 1.578-.015 2.846-.015 3.229 0 .309.21.678.825.56 4.801-1.548 8.236-5.97 8.236-11.173 0-6.512-5.373-11.792-12-11.792z"
      fill={props.color}
    />
  </svg>
)

const BehanceIcon = props => (
  <svg
    x="0px"
    y="0px"
    width={props.width}
    height={props.height}
    viewBox="0 0 97.75 97.75"
    fill={props.color}
  >
    <g>
      <path d="M39.337,38.729c0-4.611-3.137-4.611-3.137-4.611h-1.661H23.294v9.894H35.4C37.492,44.011,39.337,43.342,39.337,38.729z" />
      <path d="M36.201,50.846H23.294v11.85h12.311c1.852-0.053,5.27-0.633,5.27-5.76C40.875,50.784,36.201,50.846,36.201,50.846z" />
      <path d="M69.243,44.011c-6.849,0-7.804,6.835-7.804,6.835h14.565C76.005,50.846,76.092,44.011,69.243,44.011z" />
      <path
        d="M48.875,0C21.882,0,0,21.883,0,48.875S21.882,97.75,48.875,97.75S97.75,75.867,97.75,48.875S75.868,0,48.875,0z
			 M59.531,28.848h18.294v5.46H59.531V28.848z M50.285,57.486c0,13.533-14.084,13.088-14.084,13.088H23.294h-0.379h-9.787V26.236
			h9.787h0.379H36.2c7.012,0,12.547,3.871,12.547,11.805c0,7.935-6.766,8.438-6.766,8.438C50.9,46.479,50.285,57.486,50.285,57.486z
			 M69.33,64.479c7.37,0,7.109-4.77,7.109-4.77h7.803c0,12.659-15.172,11.792-15.172,11.792c-18.207,0-17.036-16.95-17.036-16.95
			S52.02,37.517,69.068,37.517c17.947,0,15.434,19.245,15.434,19.245H61.527C61.527,65.001,69.33,64.479,69.33,64.479z"
      />
    </g>
  </svg>
)

const DribbbleIcon = props => (
  <svg
    viewBox="0 0 512 512"
    width={props.width}
    height={props.height}
    fill={props.color}
  >
    <path d="m333.023438 279.15625c25.109374 63.527344 43.753906 128.929688 55.871093 195.746094 17.285157-10.539063 33.441407-23.203125 48.125-37.882813 38.140625-38.144531 62.753907-86.207031 71.449219-138.371093-37.46875-15.5-78.503906-24.078126-121.507812-24.078126-18.382813 0-36.398438 1.585938-53.9375 4.585938zm0 0" />
    <path d="m437.234375 75.199219c-.074219-.070313-.144531-.148438-.214844-.21875-48.355469-48.351563-112.640625-74.980469-181.019531-74.980469-26.738281 0-52.851562 4.089844-77.628906 11.941406 39.714844 49.757813 74.652344 102.859375 104.59375 158.980469 56.40625-23.949219 108.363281-56.398437 154.269531-95.722656zm0 0" />
    <path d="m457.347656 97.859375c-48.15625 41.363281-101.96875 74.882813-160.527344 99.933594 8.632813 17.378906 16.785157 35.035156 24.480469 52.953125 21.488281-4.089844 43.414063-6.175782 65.660157-6.175782 43.089843 0 85 7.75 124.769531 23.003907.171875-3.84375.269531-7.699219.269531-11.570313 0-58.09375-19.226562-113.222656-54.652344-158.144531zm0 0" />
    <path d="m98.425781 457.800781c44.816407 35.140625 99.730469 54.199219 157.574219 54.199219 36.765625 0 72.34375-7.710938 104.902344-22.34375-12.203125-70.710938-31.742188-138.9375-57.8125-203.871094-90.597656 24.726563-165.238282 88.484375-204.664063 172.015625zm0 0" />
    <path d="m251.160156 271.992188c13.167969-5.570313 26.589844-10.289063 40.222656-14.171876-7.195312-16.476562-14.828124-32.71875-22.859374-48.730468-69.160157 25.679687-141.882813 38.691406-216.585938 38.691406-17.355469 0-34.597656-.714844-51.714844-2.113281-.1367185 3.433593-.222656 6.878906-.222656 10.335937 0 68.378906 26.628906 132.664063 74.980469 181.015625.015625.015625.035156.03125.050781.046875 16.722656-33.351562 38.59375-63.664062 65.242188-90.316406 32.035156-32.03125 69.339843-57.183594 110.886718-74.757812zm0 0" />
    <path d="m254.492188 182.144531c-30.378907-56.261719-65.921876-109.34375-105.980469-158.617187-26.996094 12.503906-51.867188 29.789062-73.53125 51.453125-38.734375 38.734375-63.511719 87.699219-71.839844 140.800781 16.09375 1.316406 32.367187 2 48.796875 2 71.101562 0 139.324219-12.585938 202.554688-35.636719zm0 0" />
  </svg>
)

const LinkedInIcon = props => (
  <svg
    width={props.width}
    height={props.height}
    viewBox="0 0 512 512"
    fill={props.color}
  >
    <path d="m256 0c-141.363281 0-256 114.636719-256 256s114.636719 256 256 256 256-114.636719 256-256-114.636719-256-256-256zm-74.390625 387h-62.347656v-187.574219h62.347656zm-31.171875-213.1875h-.40625c-20.921875 0-34.453125-14.402344-34.453125-32.402344 0-18.40625 13.945313-32.410156 35.273437-32.410156 21.328126 0 34.453126 14.003906 34.859376 32.410156 0 18-13.53125 32.402344-35.273438 32.402344zm255.984375 213.1875h-62.339844v-100.347656c0-25.21875-9.027343-42.417969-31.585937-42.417969-17.222656 0-27.480469 11.601563-31.988282 22.800781-1.648437 4.007813-2.050781 9.609375-2.050781 15.214844v104.75h-62.34375s.816407-169.976562 0-187.574219h62.34375v26.558594c8.285157-12.78125 23.109375-30.960937 56.1875-30.960937 41.019531 0 71.777344 26.808593 71.777344 84.421874zm0 0" />
  </svg>
)

const BootstrapIcon = props => (
  <svg
    viewBox="0 0 32 32"
    width={props.width}
    height={props.height}
    fill={props.color}
  >
    <path d="M26.667 0h-21.333c-2.943 0.010-5.323 2.391-5.333 5.333v21.333c0 2.932 2.401 5.333 5.333 5.333h21.333c2.932 0 5.333-2.401 5.333-5.333v-21.333c0-2.932-2.401-5.333-5.333-5.333zM23.75 22.474c-0.266 0.641-0.688 1.208-1.229 1.646-0.563 0.453-1.271 0.828-2.146 1.094-0.87 0.271-1.906 0.406-3.109 0.406h-8.573v-18.667h9.068c1.677 0 3.021 0.375 4.026 1.146 1.016 0.771 1.516 1.927 1.516 3.479 0 0.943-0.229 1.745-0.688 2.411s-1.12 1.182-1.974 1.542v0.063c1.141 0.24 2.021 0.781 2.599 1.62s0.88 1.901 0.88 3.182c0 0.719-0.141 1.401-0.401 2.036l0.031 0.036zM20.047 17.875c-0.542-0.5-1.313-0.745-2.302-0.745h-5.766v5.823h5.781c0.984 0 1.76-0.255 2.307-0.771s0.823-1.25 0.823-2.188c-0.010-0.922-0.276-1.635-0.823-2.12h-0.026zM19.25 14.109c0.526-0.448 0.786-1.089 0.786-1.927 0-0.938-0.234-1.604-0.708-1.984-0.469-0.38-1.146-0.578-2.036-0.578h-5.333v5.151h5.333c0.776 0 1.443-0.229 1.953-0.661z" />
  </svg>
)

const CSSIcon = props => (
  <svg
    viewBox="0 0 512 512"
    width={props.width}
    height={props.height}
    fill={props.color}
  >
    <g>
      <g>
        <path
          d="M32,0l40.8,460.8L256,512l183.136-51.168L480,0H32z M392.768,150.688l-5.152,57.888l-15.52,173.568L256,414.208
			l-0.064,0.032l-116-32.128l-8.128-90.752h56.832l4.224,47.104l63.072,17.024l0.064-0.064l63.136-17.024l8.608-78.432
			l-198.656,0.544l-5.632-53.664l209.056-2.432l4.224-57.44l-218.88,0.608l-3.68-53.376H256h141.824L392.768,150.688z"
        />
      </g>
    </g>
  </svg>
)

const SCSSIcon = props => (
  <svg
    width={props.width}
    height={props.height}
    fill={props.color}
    viewBox="0 0 24 24"
  >
    <path d="M12 0c6.627 0 12 5.373 12 12s-5.373 12-12 12S0 18.627 0 12 5.373 0 12 0zM9.615 15.998c.175.645.156 1.248-.024 1.792l-.065.18c-.024.061-.052.12-.078.176-.14.29-.326.56-.555.81-.698.759-1.672 1.047-2.09.805-.45-.262-.226-1.335.584-2.19.871-.918 2.12-1.509 2.12-1.509v-.003l.108-.061zm9.911-10.861c-.542-2.133-4.077-2.834-7.422-1.645-1.989.707-4.144 1.818-5.693 3.267C4.568 8.48 4.275 9.98 4.396 10.607c.427 2.211 3.457 3.657 4.703 4.73v.006c-.367.18-3.056 1.529-3.686 2.925-.675 1.47.105 2.521.615 2.655 1.575.436 3.195-.36 4.065-1.649.84-1.261.766-2.881.404-3.676.496-.135 1.08-.195 1.83-.104 2.101.24 2.521 1.56 2.43 2.1-.09.539-.523.854-.674.944-.15.091-.195.12-.181.181.015.09.091.09.21.075.165-.03 1.096-.45 1.141-1.471.045-1.29-1.186-2.729-3.375-2.7-.9.016-1.471.091-1.875.256-.03-.045-.061-.075-.105-.105-1.35-1.455-3.855-2.475-3.75-4.41.03-.705.285-2.564 4.8-4.814 3.705-1.846 6.661-1.335 7.171-.21.733 1.604-1.576 4.59-5.431 5.024-1.47.165-2.235-.404-2.431-.615-.209-.225-.239-.24-.314-.194-.12.06-.045.255 0 .375.12.3.585.825 1.396 1.095.704.225 2.43.359 4.5-.45 2.324-.899 4.139-3.405 3.614-5.505l.073.067z"></path>
  </svg>
)

const JavaScriptIcon = props => (
  <svg
    viewBox="0 0 24 24"
    width={props.width}
    height={props.height}
    fill={props.color}
  >
    <path d="M0 0h24v24H0V0zm22.034 18.276c-.175-1.095-.888-2.015-3.003-2.873-.736-.345-1.554-.585-1.797-1.14-.091-.33-.105-.51-.046-.705.15-.646.915-.84 1.515-.66.39.12.75.42.976.9 1.034-.676 1.034-.676 1.755-1.125-.27-.42-.404-.601-.586-.78-.63-.705-1.469-1.065-2.834-1.034l-.705.089c-.676.165-1.32.525-1.71 1.005-1.14 1.291-.811 3.541.569 4.471 1.365 1.02 3.361 1.244 3.616 2.205.24 1.17-.87 1.545-1.966 1.41-.811-.18-1.26-.586-1.755-1.336l-1.83 1.051c.21.48.45.689.81 1.109 1.74 1.756 6.09 1.666 6.871-1.004.029-.09.24-.705.074-1.65l.046.067zm-8.983-7.245h-2.248c0 1.938-.009 3.864-.009 5.805 0 1.232.063 2.363-.138 2.711-.33.689-1.18.601-1.566.48-.396-.196-.597-.466-.83-.855-.063-.105-.11-.196-.127-.196l-1.825 1.125c.305.63.75 1.172 1.324 1.517.855.51 2.004.675 3.207.405.783-.226 1.458-.691 1.811-1.411.51-.93.402-2.07.397-3.346.012-2.054 0-4.109 0-6.179l.004-.056z"></path>
  </svg>
)

const HTMLIcon = props => (
  <svg
    viewBox="0 0 24 24"
    width={props.width}
    height={props.height}
    fill={props.color}
  >
    <path d="M1.5 0h21l-1.91 21.563L11.977 24l-8.564-2.438L1.5 0zm7.031 9.75l-.232-2.718 10.059.003.23-2.622L5.412 4.41l.698 8.01h9.126l-.326 3.426-2.91.804-2.955-.81-.188-2.11H6.248l.33 4.171L12 19.351l5.379-1.443.744-8.157H8.531z"></path>
  </svg>
)

const ReactIcon = props => (
  <svg
    viewBox="0 0 24 24"
    width={props.width}
    height={props.height}
    fill={props.color}
  >
    <path d="M12 9.861A2.139 2.139 0 1 0 12 14.139 2.139 2.139 0 1 0 12 9.861zM6.008 16.255l-.472-.12C2.018 15.246 0 13.737 0 11.996s2.018-3.25 5.536-4.139l.472-.119.133.468a23.53 23.53 0 0 0 1.363 3.578l.101.213-.101.213a23.307 23.307 0 0 0-1.363 3.578l-.133.467zM5.317 8.95c-2.674.751-4.315 1.9-4.315 3.046 0 1.145 1.641 2.294 4.315 3.046a24.95 24.95 0 0 1 1.182-3.046A24.752 24.752 0 0 1 5.317 8.95zM17.992 16.255l-.133-.469a23.357 23.357 0 0 0-1.364-3.577l-.101-.213.101-.213a23.42 23.42 0 0 0 1.364-3.578l.133-.468.473.119c3.517.889 5.535 2.398 5.535 4.14s-2.018 3.25-5.535 4.139l-.473.12zm-.491-4.259c.48 1.039.877 2.06 1.182 3.046 2.675-.752 4.315-1.901 4.315-3.046 0-1.146-1.641-2.294-4.315-3.046a24.788 24.788 0 0 1-1.182 3.046zM5.31 8.945l-.133-.467C4.188 4.992 4.488 2.494 6 1.622c1.483-.856 3.864.155 6.359 2.716l.34.349-.34.349a23.552 23.552 0 0 0-2.422 2.967l-.135.193-.235.02a23.657 23.657 0 0 0-3.785.61l-.472.119zm1.896-6.63c-.268 0-.505.058-.705.173-.994.573-1.17 2.565-.485 5.253a25.122 25.122 0 0 1 3.233-.501 24.847 24.847 0 0 1 2.052-2.544c-1.56-1.519-3.037-2.381-4.095-2.381zM16.795 22.677c-.001 0-.001 0 0 0-1.425 0-3.255-1.073-5.154-3.023l-.34-.349.34-.349a23.53 23.53 0 0 0 2.421-2.968l.135-.193.234-.02a23.63 23.63 0 0 0 3.787-.609l.472-.119.134.468c.987 3.484.688 5.983-.824 6.854a2.38 2.38 0 0 1-1.205.308zm-4.096-3.381c1.56 1.519 3.037 2.381 4.095 2.381h.001c.267 0 .505-.058.704-.173.994-.573 1.171-2.566.485-5.254a25.02 25.02 0 0 1-3.234.501 24.674 24.674 0 0 1-2.051 2.545zM18.69 8.945l-.472-.119a23.479 23.479 0 0 0-3.787-.61l-.234-.02-.135-.193a23.414 23.414 0 0 0-2.421-2.967l-.34-.349.34-.349C14.135 1.778 16.515.767 18 1.622c1.512.872 1.812 3.37.824 6.855l-.134.468zM14.75 7.24c1.142.104 2.227.273 3.234.501.686-2.688.509-4.68-.485-5.253-.988-.571-2.845.304-4.8 2.208A24.849 24.849 0 0 1 14.75 7.24zM7.206 22.677A2.38 2.38 0 0 1 6 22.369c-1.512-.871-1.812-3.369-.823-6.854l.132-.468.472.119c1.155.291 2.429.496 3.785.609l.235.02.134.193a23.596 23.596 0 0 0 2.422 2.968l.34.349-.34.349c-1.898 1.95-3.728 3.023-5.151 3.023zm-1.19-6.427c-.686 2.688-.509 4.681.485 5.254.987.563 2.843-.305 4.8-2.208a24.998 24.998 0 0 1-2.052-2.545 24.976 24.976 0 0 1-3.233-.501zM12 16.878c-.823 0-1.669-.036-2.516-.106l-.235-.02-.135-.193a30.388 30.388 0 0 1-1.35-2.122 30.354 30.354 0 0 1-1.166-2.228l-.1-.213.1-.213a30.3 30.3 0 0 1 1.166-2.228c.414-.716.869-1.43 1.35-2.122l.135-.193.235-.02a29.785 29.785 0 0 1 5.033 0l.234.02.134.193a30.006 30.006 0 0 1 2.517 4.35l.101.213-.101.213a29.6 29.6 0 0 1-2.517 4.35l-.134.193-.234.02c-.847.07-1.694.106-2.517.106zm-2.197-1.084c1.48.111 2.914.111 4.395 0a29.006 29.006 0 0 0 2.196-3.798 28.585 28.585 0 0 0-2.197-3.798 29.031 29.031 0 0 0-4.394 0 28.477 28.477 0 0 0-2.197 3.798 29.114 29.114 0 0 0 2.197 3.798z"></path>
  </svg>
)

const GatsbyIcon = props => (
  <svg
    viewBox="0 0 24 24"
    width={props.width}
    height={props.height}
    fill={props.color}
  >
    <path d="M12,2A10,10 0 0,1 22,12A10,10 0 0,1 12,22A10,10 0 0,1 2,12A10,10 0 0,1 12,2M12,4C8.27,4 5.14,6.55 4.25,10L14,19.75C17.45,18.86 20,15.73 20,12H14.75V13.5H18.2C17.71,15.54 16.24,17.19 14.31,17.94L6.06,9.69C7,7.31 9.3,5.63 12,5.63C14.13,5.63 16,6.67 17.18,8.28L18.41,7.22C16.95,5.26 14.63,4 12,4M4,12A8,8 0 0,0 12,20C12.04,20 12.09,20 4,12Z" />
  </svg>
)

const FirebaseIcon = props => (
  <svg
    viewBox="0 0 32 32"
    width={props.width}
    height={props.height}
    fill={props.color}
  >
    <path d="M5.188 20.896l3.151-20.281c0.104-0.688 1.031-0.844 1.354-0.229l3.391 6.359zM27.578 25.818l-3-18.667c-0.099-0.578-0.807-0.802-1.224-0.391l-18.932 19.057 10.474 5.906c0.656 0.37 1.458 0.37 2.115 0zM19.068 9.531l-2.427-4.646c-0.271-0.516-1.010-0.516-1.281 0l-10.651 19.094z" />
  </svg>
)

const TailwindIcon = props => (
  <svg
    width={props.width}
    height={props.height}
    fill={props.color}
    viewBox="0 0 32 32"
  >
    <path d="M9,13.7q1.4-5.6,7-5.6c5.6,0,6.3,4.2,9.1,4.9q2.8.7,4.9-2.1-1.4,5.6-7,5.6c-5.6,0-6.3-4.2-9.1-4.9Q11.1,10.9,9,13.7ZM2,22.1q1.4-5.6,7-5.6c5.6,0,6.3,4.2,9.1,4.9q2.8.7,4.9-2.1-1.4,5.6-7,5.6c-5.6,0-6.3-4.2-9.1-4.9Q4.1,19.3,2,22.1Z" />
  </svg>
)

const SketchIcon = props => (
  <svg
    viewBox="0 0 128 128"
    width={props.width}
    height={props.height}
    fill={props.color}
  >
    <g id="original">
      <path d="M29.62,12.85,64,9.24l34.38,3.61L125,48.29,64,118.76,3,48.29Z" />
      <polygon points="27.71 48.29 64 118.76 3 48.29 27.71 48.29" />
      <polygon points="100.29 48.29 64 118.76 125 48.29 100.29 48.29" />
      <polygon points="27.71 48.29 100.29 48.29 64 118.76 27.71 48.29" />
      <polygon
        className="cls-4"
        points="64 9.24 29.62 12.85 27.71 48.29 64 9.24"
      />
      <polygon points="64 9.24 98.38 12.85 100.29 48.29 64 9.24" />
      <polygon points="125 48.29 98.38 12.85 100.29 48.29 125 48.29" />
      <polygon points="64 9.24 27.71 48.29 100.29 48.29 64 9.24" />
      <polygon
        className="cls-3"
        points="3 48.29 29.62 12.85 27.71 48.29 3 48.29"
      />
    </g>
  </svg>
)

const SuccessIcon = props => (
  <svg
    id="successAnimation"
    className="animated"
    height={props.height}
    width={props.width}
    viewBox="0 0 70 70"
  >
    <path
      id="successAnimationResult"
      fill="#D8D8D8"
      d="M35,60 C21.1928813,60 10,48.8071187 10,35 C10,21.1928813 21.1928813,10 35,10 C48.8071187,10 60,21.1928813 60,35 C60,48.8071187 48.8071187,60 35,60 Z M23.6332378,33.2260427 L22.3667622,34.7739573 L34.1433655,44.40936 L47.776114,27.6305926 L46.223886,26.3694074 L33.8566345,41.59064 L23.6332378,33.2260427 Z"
    />
    <circle
      id="successAnimationCircle"
      cx="200"
      cy="200"
      r="24"
      stroke="#979797"
      strokeWidth="2"
      strokeLinecap="round"
      fill="transparent"
    />
    <polyline
      id="successAnimationCheck"
      stroke="#979797"
      strokeWidth="2"
      points="23 34 34 43 47 27"
      fill="transparent"
    />
  </svg>
)

const FailureIcon = props => (
  <svg
    id="failureAnimation"
    viewBox="0 0 70 70"
    height={props.height}
    width={props.width}
  >
    <circle
      id="failureAnimationCircle"
      cx="35"
      cy="35"
      r="24"
      stroke="#D50000"
      strokeWidth="3"
      strokeLinecap="round"
      fill="transparent"
    />
    <polyline
      className="failureAnimationCheckLine"
      stroke="#D50000"
      strokeWidth="3"
      points="25,25 45,45"
      fill="transparent"
    />
    <polyline
      className="failureAnimationCheckLine"
      stroke="#D50000"
      strokeWidth="3"
      points="45,25 25,45"
      fill="transparent"
    />
  </svg>
)

const LoaderIcon = props => (
  <svg
    width={props.width}
    height={props.height}
    fill={props.color}
    viewBox="0 0 40 40"
    enableBackground="new 0 0 40 40"
  >
    <path
      opacity="0.2"
      fill="#000"
      d="M20.201,5.169c-8.254,0-14.946,6.692-14.946,14.946c0,8.255,6.692,14.946,14.946,14.946
    s14.946-6.691,14.946-14.946C35.146,11.861,28.455,5.169,20.201,5.169z M20.201,31.749c-6.425,0-11.634-5.208-11.634-11.634
    c0-6.425,5.209-11.634,11.634-11.634c6.425,0,11.633,5.209,11.633,11.634C31.834,26.541,26.626,31.749,20.201,31.749z"
    />
    <path
      fill="#000"
      d="M26.013,10.047l1.654-2.866c-2.198-1.272-4.743-2.012-7.466-2.012h0v3.312h0
    C22.32,8.481,24.301,9.057,26.013,10.047z"
    >
      <animateTransform
        attributeType="xml"
        attributeName="transform"
        type="rotate"
        from="0 20 20"
        to="360 20 20"
        dur="0.5s"
        repeatCount="indefinite"
      />
    </path>
  </svg>
)

export {
  GithubIcon,
  BehanceIcon,
  LinkedInIcon,
  DribbbleIcon,
  BootstrapIcon,
  CSSIcon,
  SCSSIcon,
  JavaScriptIcon,
  HTMLIcon,
  ReactIcon,
  GatsbyIcon,
  FirebaseIcon,
  TailwindIcon,
  SketchIcon,
  SuccessIcon,
  FailureIcon,
  LoaderIcon,
}
